import { render, staticRenderFns } from "./left-catalogue.vue?vue&type=template&id=99350958&scoped=true&"
import script from "./left-catalogue.vue?vue&type=script&lang=js&"
export * from "./left-catalogue.vue?vue&type=script&lang=js&"
import style0 from "./left-catalogue.vue?vue&type=style&index=0&id=99350958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99350958",
  null
  
)

export default component.exports